import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Header.css";
import logo from "../assets/ssb.png";
import fbIcon from "../assets/fb.png";
import whatsappIcon from "../assets/whatapps.png";
import ApplyNowModal from "./ApplyNowModal";

function Header() {
  const [isModalOpen, setModalOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-container">
        {/* Logo */}
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="Website Logo" />
          </Link>
        </div>

        {/* Social Media Icons */}
        <div className="social-icons">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
            <img src={fbIcon} alt="Facebook" />
          </a>
          <a href="https://wa.me/91772839373" target="_blank" rel="noopener noreferrer">
            <img src={whatsappIcon} alt="WhatsApp" />
          </a>
        </div>

        {/* Contact Info */}
        <div className="contact-info">
          <p>Questions? Call us: <strong>+91 772839373</strong></p>
        </div>

        {/* Navigation Bar */}
        <nav className="nav-bar">
          <button className="apply-btn" onClick={() => setModalOpen(true)}>
            Apply Now
          </button>
        </nav>
      </div>

      {/* Apply Now Modal */}
      {isModalOpen && <ApplyNowModal onClose={() => setModalOpen(false)} />}
    </header>
  );
}

export default Header;
